import { Environment } from '../environment';

export const environment: Environment = {
    apiUrl: 'https://dev-api-qms.techcrowd.space',
    development: true,
};
